import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { VisitorEngagementAndAddToCartGraph } from "../../../../components/Graphs/graphs";
import { graphSessionDistribution, SelectStatus, SelectWeeks, SelectPercentVisitors,SelectPercentBooking,  SelectPercentBuying, SelectGraphLabels } from "./sessionDistributionSlice";
import { FourGraphLoading, SingleGraphLoading } from "../../../../components/Skeletons";


const SessionDistribution = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  
  // const SessionDistributionData = useSelector(state => state.sessionDistribution)
  const loading = useSelector(SelectStatus);
  const percentVisitors = useSelector(SelectPercentVisitors)
  const percentBooking = useSelector(SelectPercentBooking)
  const percentBuying = useSelector(SelectPercentBuying)
  const weeks = useSelector(SelectWeeks)
  const nameLabels = useSelector(SelectGraphLabels)
  
  useEffect(() => {
    if (!user) return null;
    if(weeks.length===0) dispatch(graphSessionDistribution(user));
  }, [user, weeks])

  if (loading === 'loading') {
    if (display === 'dashboard') return <FourGraphLoading />
    else return <SingleGraphLoading/>
  } 
  
  return (
      <VisitorEngagementAndAddToCartGraph
        display={display}
        weeks={weeks}
        percentVisitors={percentVisitors}
        percentBooking={percentBooking}
        percentBuying={percentBuying}
        nameLabels={nameLabels}
    />
  )
}

export default SessionDistribution;